// extracted by mini-css-extract-plugin
var _1 = "TeammatesRow-module__animatedBackground--b99Ce";
var _2 = "TeammatesRow-module__avatar--nMp_Z";
var _3 = "TeammatesRow-module__deactivated--PDTM6";
var _4 = "TeammatesRow-module__email--Af2Ts";
var _5 = "TeammatesRow-module__menu--Y711s";
var _6 = "TeammatesRow-module__name--xcwHb";
var _7 = "TeammatesRow-module__row--HZA3X";
var _8 = "TeammatesRow-module__status--kdab7";
var _9 = "TeammatesRow-module__type--LDco6";
export { _1 as "animatedBackground", _2 as "avatar", _3 as "deactivated", _4 as "email", _5 as "menu", _6 as "name", _7 as "row", _8 as "status", _9 as "type" }
